export default __webpack_public_path__ + "static/media/link-2.24dc599b.svg";